<p>Old number of days remaining: {{ oldDaysRemaining }}</p>

<!--suppress TypeScriptValidateTypes -->
<p *ngIf="[CustomerMembershipStatus.active, CustomerMembershipStatus.renewalPaymentProcessing].includes(membership.status)">
  End date before change: {{ dateStringFromISO8601(membership.end_date) }}
  <br>
  End date after change: <b>{{ endDateAfterChange() }}</b>
</p>

<div class="form-group">
  <label for="newDaysRemaining">New number of days remaining</label>
  <input class="form-control"
         type="number" step="1" min="0"
         id="newDaysRemaining"
         name="newDaysRemaining"
         [(ngModel)]="newDaysRemaining">
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
